import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="bg-orange py-16 px-4 relative overflow-hidden" data-id="element-128">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-white/10 rounded-full blur-[150px] pointer-events-none" data-id="element-129"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-130">
        <div className="text-center mb-10" data-id="element-131">
          <h2 className="text-lg md:text-2xl font-heading font-bold mb-4 flex items-center justify-center tracking-wide text-white" data-id="element-132">
            <span className="mr-2" data-id="element-133">⏰</span> LAUNCH PRICE — OFFER CLOSES IN:
          </h2>
          <Countdown data-id="element-134" />
          <p className="text-white mt-4 flex items-center justify-center text-sm md:text-base font-bold bg-black/20 inline-flex px-4 py-2 rounded-full border border-white/20" data-id="element-135">
            <span className="text-gold mr-2" data-id="element-136">⚠️</span> After this the price goes
            up. It does not come back.
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-137">
          <motion.div whileHover={{
          y: -8
        }} className="bg-white rounded-2xl p-8 md:p-12 border-4 border-navy flex flex-col h-full shadow-2xl relative" data-id="element-138">
            <div className="text-center mb-6" data-id="element-139">
              <h3 className="text-2xl md:text-3xl font-heading font-black text-navy mb-2 flex items-center justify-center" data-id="element-140">
                <span className="mr-3" data-id="element-141">📘</span> YOUR INVESTMENT TODAY
              </h3>
              <p className="text-orange font-bold text-lg md:text-xl mb-2" data-id="element-142">
                MEGAPACK NEURO-KID™ COMPLETE
              </p>
              <p className="text-muted font-bold text-sm md:text-base mb-6" data-id="element-143">
                6 Tomes + 5 Bonuses — 300+ Printable Pages
              </p>
              <div className="bg-lightgray rounded-xl py-4 px-6 inline-block mb-2 border border-border" data-id="element-144">
                <p className="text-sm md:text-base font-medium text-ink" data-id="element-145">
                  Perfect for parents who want their child to build real focus,
                  memory, and self-control — without screens, without arguments,
                  and without spending hours planning activities.
                </p>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-146">
              <p className="line-through text-lg md:text-xl mb-2 text-muted font-medium" data-id="element-147">
                $175
              </p>
              <div className="flex items-start justify-center bg-[#FBE14D]" data-id="element-148">
                <span className="text-2xl md:text-3xl text-navy mt-1 mr-1 font-bold" data-id="element-149">
                  $
                </span>
                <span className="text-5xl md:text-7xl font-heading font-black text-navy" data-id="element-150">
                  19
                </span>
                <span className="text-base md:text-2xl text-navy mt-auto mb-2 ml-2 font-bold" data-id="element-151">
                  USD
                </span>
              </div>
              <p className="text-sm md:text-base font-bold text-muted max-w-md mx-auto mt-4" data-id="element-152">
                That's less than a single trip to the toy store — and this one
                actually builds your child's brain.
              </p>
            </div>

            <a href="https://neuro-kid.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="block w-full bg-orange hover:bg-orange-dark text-white font-heading font-bold py-5 px-6 rounded-full transition-all text-center text-base md:text-lg shadow-lg hover:scale-[1.02] active:scale-95 mb-3" data-id="element-153">
              YES — Give My Child The Focus They Deserve →
            </a>
            <p className="text-center text-sm font-bold text-muted uppercase tracking-wider" data-id="element-154">
              INSTANT ACCESS FOR JUST $19 USD
            </p>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-white font-medium bg-black/20 py-5 px-8 rounded-2xl border border-white/20 max-w-4xl mx-auto shadow-sm" data-id="element-155">
          <div className="flex items-center" data-id="element-156">
            <Shield className="w-5 h-5 mr-2 text-green" data-id="element-157" /> 7-Day Guarantee
          </div>
          <div className="flex items-center" data-id="element-158">
            <Lock className="w-5 h-5 mr-2 text-green" data-id="element-159" /> Secure Payment
          </div>
          <div className="flex items-center" data-id="element-160">
            <Zap className="w-5 h-5 mr-2 text-gold" data-id="element-161" /> Access in 5 Minutes
          </div>
          <div className="flex items-center w-full justify-center md:w-auto mt-2 md:mt-0" data-id="element-162">
            <CreditCard className="w-5 h-5 mr-2 text-white" data-id="element-163" /> Visa | Mastercard
            | PayPal | Stripe
          </div>
        </div>
      </div>
    </section>;
}